function setupGroupedTagToCategory($tag, $category) {
  let changeCategory = function () {
    let id = $tag.find(":selected").parent().attr("data-category-id") - 0;
    $category.val(id);
  };
  changeCategory();
  $tag.on("change", changeCategory);
}

export default setupGroupedTagToCategory;
